// src/hooks/useAnnCostInv.js
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

const ANN_COST_INV_QUERY = gql`
  query AnnCostInvSector($scenario: String) {
    timeSeries(view: ANN_COST_INV_SECTOR, scenario: $scenario) {
      year
      scenario
      group
      value
    }
  }
`;

export function useAnnCostInv({ from, to, scenario } = {}) {
  const { data, loading, error } = useQuery(ANN_COST_INV_QUERY, {
    variables: { scenario },
    fetchPolicy: "cache-first",
  });
  const labels = useMemo(() => {
    const years = new Set();
    for (const r of data?.timeSeries ?? []) {
      if (typeof r.year !== "number") continue;
      if (from && r.year < from) continue;
      if (to && r.year > to) continue;
      years.add(r.year);
    }
    return Array.from(years).sort((a, b) => a - b).map(String);
  }, [data, from, to]);

  // Sum values per year (just in case multiples exist)
  const series = useMemo(() => {
    const byYear = new Map();
    for (const r of data?.timeSeries ?? []) {
      if (from && r.year < from) continue;
      if (to && r.year > to) continue;
      if (typeof r.value !== "number" || !Number.isFinite(r.value)) continue;
      byYear.set(r.year, (byYear.get(r.year) ?? 0) + r.value);
    }
    return labels.map((y) => byYear.get(Number(y)) ?? 0);
  }, [data, labels, from, to]);

  return { labels, series, loading, error };
}

